import asBentoPage from 'common/bento/hoc/asBentoPage';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';

import ReviewAddressPage from '../ReviewAddress';
import { ReviewAddressProps } from '../ReviewAddress/ReviewAddress';
import locales from './locales';

interface SelectAccommodationTypeProps extends ReviewAddressProps {
  onSelfHosted: () => void;
  onHosted: () => void;
}

/**
 * A page that asks the user to confirm their address
 * and select whether they are hosted or not
 */
const SelectAccommodationType = asBentoPage<SelectAccommodationTypeProps>(
  (props) => (
    <ReviewAddressPage {...props} data-testid="select-accommodation-type">
      <Text
        fontWeight="weight-500"
        marginBottom="space-8"
        size="lg"
        variant="primary"
      >
        2. {locales.subTitleAddProofOfAddress}
      </Text>

      <SunshineCard.Group isBoxed={false}>
        <SunshineCard
          onClick={props.onSelfHosted}
          title={locales.selfHostedLabel}
        >
          <SunshineCard.Slot name="action">
            <SunshineCard.SunshineIcon name="chevron-right" />
          </SunshineCard.Slot>
        </SunshineCard>

        <SunshineCard onClick={props.onHosted} title={locales.hostedLabel}>
          <SunshineCard.Slot name="action">
            <SunshineCard.SunshineIcon name="chevron-right" />
          </SunshineCard.Slot>
        </SunshineCard>
      </SunshineCard.Group>
    </ReviewAddressPage>
  ),
);

export default SelectAccommodationType;
